export const PARTNER_SITUATIONS = {
  INCOMPLETE: 'Incompleta',
  PRE_ACCREDITED: 'Pré-Credenciada',
  ACCREDITED: 'Credenciada',
  UNACCREDITED: 'Descredenciada',
  SUSPENDED: 'Suspensa',
};
